import React from "react";
import htmlIcon from "../../../images/icons/icons-html.png";
import cssIcon from "../../../images/icons/icons8-css3-48.png";
import jsIcon from "../../../images/icons/icons-javascript.png";
import reactIcon from "../../../images/icons/icons-react.png";
// import nodeIcon from "../../../images/icons/icons-nodejs.png";
import sassIcon from "../../../images/icons/icons-sass.png";
import gitIcon from "../../../images/icons/icons-git.png";
import codepenIcon from "../../../images/icons/icons-codepen.png";
import jsxIcon from "../../../images/icons/jsx-icon.png";
import muiIcon from "../../../images/icons/icons-material-ui.png";
import vsCodeIcon from "../../../images/icons/icons-visual-studio-code.png";

export const TechSkills = () => {
  return (
    <>
      <div className="tech-skills">
        <h1>Технічні навички</h1>
        <ul className="skills-list">
          <li>
            <img className="skills-icon" src={vsCodeIcon} alt="vs-icon" />
            <p>VS-code</p>
          </li>
          <li>
            <img className="skills-icon" src={htmlIcon} alt="html-icon" />
            <p>HTML5</p>
          </li>
          <li>
            <img className="skills-icon" src={cssIcon} alt="css-icon" />
            <p> CSS3</p>
          </li>
          <li>
            <img className="skills-icon" src={jsIcon} alt="js-icon" />
            <p>JavaScript</p>
          </li>
          <li>
            <img className="skills-icon" src={reactIcon} alt="react-icon" />
            <p>React.js</p>
          </li>
          <li>
            <img className="skills-icon" src={jsxIcon} alt="jsx-icon" />
            <p>JSX</p>
          </li>
          <li>
            <img className="skills-icon" src={muiIcon} alt="mui-icon" />
            <p>MUI</p>
          </li>
          <li>
            <img className="skills-icon" src={codepenIcon} alt="codepen-icon" />
            <p>CodePen</p>
          </li>
          {/* <li>
            <img className="skills-icon" src={nodeIcon} alt="node-icon" />
            <p>Node.js</p>
          </li> */}
          <li>
            <img className="skills-icon" src={sassIcon} alt="sass-icon" />
            <p>Sass</p>
          </li>
          <li>
            <img className="skills-icon" src={gitIcon} alt="git-icon" />
            <p>Git</p>
          </li>
        </ul>
      </div>
    </>
  );
};
